import { forwardRef, useEffect, useState } from "react";
import { NumberInputProps } from "./Common";
import InputBox from "./InputBox";

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>((props: NumberInputProps, ref) => {
  const [hasValidationErrors, setHasValidationErrors] = useState(false);

  const hasErrors = (value: number | null) => {
    if (!props.required) {
      return false;
    }

    const hasErrors = (!!!value && value != 0)
      || (!!props.min && value < props.min)
      || (!!props.max && value > props.max);

    return hasErrors;
  }

  useEffect(() => {
    setHasValidationErrors(hasErrors(props.value));
  }, [props.value]);
  
  return <InputBox
    ref={ref}
    type="number"
    {...props}
    onKeyDown={(event) => {
      if (event.key === "Enter") {
        if (!props.onEnterPress) {
          return;
        }

        props.onEnterPress();
        return;
      }

      const bannedCharacters = ['e', 'E'];
      if (!props.allowNegative) {
        bannedCharacters.push('-', '+');
      }

      if (bannedCharacters.includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (props.numberType !== "decimal" && ['.'].includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }}
    onChange={(event) => {
      if (!event.target.value) {
        props.onChange(null);
        return;
      }

      const value = props.numberType === "decimal"
        ? parseFloat(event.target.value)
        : parseInt(event.target.value);

      if (isNaN(value)) {
        props.onChange(null);
        return;
      }

      props.onChange(value);
    }}
    hasValidationErrors={hasValidationErrors} />
});

export default NumberInput;